(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('NewEventController', NewEventController);

  /* ngInject */
  function NewEventController($state, Flash, eventService, formErrorsService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.event = { visibility: 'user' };
    vm.eventForm = {};
    vm.createEvent = createEvent;

    function createEvent(event) {
      eventService(sessionService.getAuthToken()).create(event, createEventSuccess, createEventFailure);
    }

    function createEventSuccess() {
      Flash.create('success', 'The event was successfully created.');
      $state.go('application.compliance_services.calendar');
    }

    function createEventFailure(response) {
      Flash.create('danger', 'An error occurred creating the event. Please correct the errors on the form and resubmit.');
      vm.setFormErrors(vm.eventForm, response);
    }
  }
})();
